module.exports = __webpack_public_path__ + "static/media/Github.8f8028d9.png";